import { Box, Group, Stack, Text, ThemeIcon } from '@mantine/core';

import {
  IconQuestionMark,
  IconSquareCheckFilled,
  IconX,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '../../../../../../shared/components/UI/Tooltip/Tooltip';

export function QuestionTooltip() {
  const { t } = useTranslation(['summarySheet']);

  const contentElement = (
    <Stack p="04" spacing="04">
      <Stack spacing="02">
        <QuestionTooltipContent
          type="bad"
          question={t('criteriaSidepanel.tooltips.badQuestion1')}
        />
        <QuestionTooltipContent
          type="good"
          question={t('criteriaSidepanel.tooltips.goodQuestion1')}
        />
      </Stack>
      <Stack spacing="02">
        <QuestionTooltipContent
          type="bad"
          question={t('criteriaSidepanel.tooltips.badQuestion2')}
        />
        <QuestionTooltipContent
          type="good"
          question={t('criteriaSidepanel.tooltips.goodQuestion2')}
        />
      </Stack>
    </Stack>
  );

  return (
    <Group noWrap sx={{ flex: 1 }}>
      <Tooltip
        content={contentElement}
        sx={{ pointerEvents: 'auto', cursor: 'help' }}
      >
        <Group noWrap spacing="01" pt="00" sx={{ flex: 1 }}>
          <ThemeIcon variant="outline" radius="xl" color="primary.6" size={16}>
            <IconQuestionMark stroke={2} />
          </ThemeIcon>
          <Text variant="xs" fw={500} pt="00" color="primary.6">
            {t('criteriaSidepanel.tooltips.trigger')}
          </Text>
        </Group>
      </Tooltip>
    </Group>
  );
}

type QuestionTooltipContentProps = {
  type: 'bad' | 'good';
  question: string;
};

function QuestionTooltipContent({
  type,
  question,
}: QuestionTooltipContentProps) {
  const goodIcon = (
    <Box c="green.6">
      <IconSquareCheckFilled size={16} />
    </Box>
  );
  const badIcon = (
    <Box c="red.6">
      <IconX size={16} />
    </Box>
  );

  return (
    <Group noWrap spacing="01" align="flex-start">
      {type === 'good' ? goodIcon : badIcon}
      <Text variant="xs" fw={500} pt="00">
        {question}
      </Text>
    </Group>
  );
}
